import type { IFurnovateRegularPusher } from "~/features/shopping-hub/dashboard/generate-result/types";

export const usePusherEvents = () => {
    const config = useRuntimeConfig().public;
    const { channel, pusher } = usePusher(config.pusherKey, config.pusherCluster);
    const generateEvent = (callback: (response: IFurnovateRegularPusher) => Promise<void>) => {
        channel.value?.bind("generate", async (response: IFurnovateRegularPusher) => {
            await callback(response);
        });
    };

    const errorEvent = (callback: (response: IFurnovateRegularPusher) => Promise<void>) => {
        channel.value?.bind("error", async (response: IFurnovateRegularPusher) => {
            await callback(response);
        });
    };

    const upscaleEvent = (callback: (response: { message: string; download_src: string }) => Promise<void>) => {
        channel.value?.bind("upscale", async (response: { message: string; download_src: string }) => {
            await callback(response);
        });
    };

    function unbindGenerate() {
        channel.value?.unbind("generate");
        channel.value?.unbind("error");
    }

    function unbindUpscale() {
        channel.value?.unbind("upscale");
        channel.value?.unbind("error");
    }

    const pusherState = computed(() => {
        return pusher.value?.connection.state;
    });

    return {
        //* variables
        channel,
        pusherState,
        //* functions
        generateEvent,
        unbindGenerate,
        unbindUpscale,
        errorEvent,
        upscaleEvent,
    };
};
